export const rejectFormStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: 2,
  padding: 3,
};
